import React    from 'react';
import useTheme from '@widesk-ui/hooks/useTheme';

// widesk-ui consomme des variables CSS --ant-* (liens "secondary", listes, tableaux...) dont les
// valeurs par défaut (widesk-ui/styles/style.scss) sont celles du thème clair. Le projet n'active pas
// `cssVar` sur son ConfigProvider : on pose donc nous-mêmes ces variables sur :root à partir des tokens
// du thème courant, pour qu'elles suivent le mode sombre.
export default function useSyncAntdCssVars() {
	const {
		colorBgContainer,
		colorBorder,
		colorBorderSecondary,
		colorError,
		colorFillQuaternary,
		colorIcon,
		colorPrimaryBg,
		colorText,
		colorTextDescription,
		colorTextDisabled,
		colorTextQuaternary,
		controlItemBgHover,
	} = useTheme();

	React.useEffect(() => {
		const root = document.documentElement.style;

		root.setProperty('--ant-color-text', colorText);
		root.setProperty('--ant-color-text-description', colorTextDescription);
		root.setProperty('--ant-color-text-disabled', colorTextDisabled);
		root.setProperty('--ant-color-text-quaternary', colorTextQuaternary);
		root.setProperty('--ant-color-icon', colorIcon);
		root.setProperty('--ant-color-bg-container', colorBgContainer);
		root.setProperty('--ant-color-border', colorBorder);
		root.setProperty('--ant-color-border-secondary', colorBorderSecondary);
		root.setProperty('--ant-color-fill-quaternary', colorFillQuaternary);
		root.setProperty('--ant-control-item-bg-hover', controlItemBgHover);
		root.setProperty('--ant-color-primary-bg', colorPrimaryBg);
		root.setProperty('--ant-color-error', colorError);
	}, [
		colorBgContainer,
		colorBorder,
		colorBorderSecondary,
		colorError,
		colorFillQuaternary,
		colorIcon,
		colorPrimaryBg,
		colorText,
		colorTextDescription,
		colorTextDisabled,
		colorTextQuaternary,
		controlItemBgHover,
	]);
}
